import React, { Fragment } from "react";
import { fmtCurrency } from "../helpers";

const BillPayment = ({ update, data }) => {
  return (
    <Fragment>
      {data.amt > 0 && (
        <div className="terms">
          <p className="bold" style={{ fontSize: "1.1rem" }}>
            {`100% of your ${fmtCurrency(data.amt / 100)} donation will directly
            support ${data.charity}.`}
          </p>
          <p>
            <span>
              Thank you in advance for your contribution and support, please
              consider honoring your pledge commitment before the May 18, 2021
              deadline. To complete your contribution, you can utilize your
              payment link (emailed to you after submitting this form) for
              paying by credit or debit card or print the Donation Fulfillment
              Request available on the next page to pay by cash, check or ACH.
            </span>
          </p>
        </div>
      )}
    </Fragment>
  );
};

export default BillPayment;
